import(/* webpackMode: "eager" */ "/codebuild/output/src3223353080/src/apps/webapp/src/app/global-error.tsx");
